import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ATTENDANCE } from '../../services/actions';
import { Button, Box, Typography, Tooltip } from '@mui/material';
import { MdOutlineFingerprint } from "react-icons/md";

export default function AttendanceButton() {
    const dispatch = useDispatch();
    const attendanceState = useSelector(state => state.attendanceState);

    const raw = attendanceState?.data;
    const todayLog = raw?.data && (raw.data.date || raw.data.id || raw.data.working_time) ? raw.data :
        (raw && (raw.date || raw.id || raw.working_time) ? raw : null);

    const [elapsedTime, setElapsedTime] = React.useState('');

    React.useEffect(() => {
        dispatch({ type: `${ATTENDANCE}_GET`, payload: "attendance/logs/today_status/" });
    }, [dispatch]);

    // Live timer updater
    React.useEffect(() => {
        let interval;
        const updateTimer = () => {
            if (todayLog && todayLog.punch_in_time) {
                let startTime = new Date(todayLog.punch_in_time);
                let endTime = todayLog.punch_out_time ? new Date(todayLog.punch_out_time) : new Date();

                const wt = todayLog.working_time || { start_time: "09:00:00", end_time: "18:00:00" };
                const [sH, sM, sS = 0] = wt.start_time.split(':').map(Number);
                const [eH, eM, eS = 0] = wt.end_time.split(':').map(Number);

                const startLimit = new Date(startTime);
                startLimit.setHours(sH, sM, sS, 0);

                const endLimit = new Date(startTime);
                endLimit.setHours(eH, eM, eS, 0);

                if (startTime < startLimit) {
                    startTime = startLimit;
                }
                if (endTime > endLimit) {
                    endTime = endLimit;
                }

                const diffMs = endTime - startTime;
                if (diffMs < 0) {
                    setElapsedTime('0h 0m');
                    return;
                }

                const hours = Math.floor(diffMs / (1000 * 60 * 60));
                const mins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
                setElapsedTime(`${hours}h ${mins}m (Available Time)`);
            } else {
                setElapsedTime('');
            }
        };

        updateTimer();
        interval = setInterval(updateTimer, 60000); // Update every minute

        return () => clearInterval(interval);
    }, [todayLog]);

    // Simple idle tracking mechanism
    React.useEffect(() => {
        let timeout;
        const resetIdle = () => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                dispatch({ type: `${ATTENDANCE}_POST`, payload: { url: "attendance/logs/inactive/", payload: {} } });
            }, 1000 * 60 * 15); // 15 mins inactive
        };

        window.addEventListener('mousemove', resetIdle);
        window.addEventListener('keypress', resetIdle);
        resetIdle();
        return () => {
            window.removeEventListener('mousemove', resetIdle);
            window.removeEventListener('keypress', resetIdle);
            clearTimeout(timeout);
        };
    }, [dispatch]);

    const handlePunch = () => {
        dispatch({
            type: `${ATTENDANCE}_POST`,
            payload: { url: "attendance/logs/punch/", payload: {} }
        });
    };

    let status = "Not Punched In";
    let color = "error";
    let buttonLabel = "Punch In";

    if (todayLog) {
        if (todayLog.punch_in_time && !todayLog.punch_out_time) {
            status = "Punched In / Working";
            color = "success";
            buttonLabel = "Checked In";
        } else if (todayLog.punch_in_time && todayLog.punch_out_time) {
            status = "Punched Out (Click to resume active work)";
            color = "warning";
            buttonLabel = "Checked Out";
        }
    }

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, bgcolor: color === 'success' ? '#f0fdf4' : color === 'warning' ? '#fff7ed' : '#fef2f2', px: 0.8, py: 0.4, borderRadius: '24px', border: '1px solid', borderColor: color === 'success' ? '#bbf7d0' : color === 'warning' ? '#fed7aa' : '#fecaca', flexShrink: 0 }}>
            {elapsedTime && (
                <Tooltip title={status === "Punched In / Working" ? "Active working time today" : "Available working time today"}>
                    <Typography sx={{ fontSize: '11px', fontWeight: 600, color: color === 'success' ? '#166534' : color === 'warning' ? '#c2410c' : '#991b1b', display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 0.4, px: 0.5, whiteSpace: 'nowrap' }}>
                        ⏱ {elapsedTime.replace(" (Available Time)", "")}
                    </Typography>
                </Tooltip>
            )}
            <Tooltip title={`Status: ${status}`}>
                <Button
                    variant="contained"
                    color={color}
                    onClick={handlePunch}
                    // startIcon={<MdOutlineFingerprint />}
                    size="small"
                    sx={{ borderRadius: '20px!important', p: '6px!important', textTransform: 'none', fontWeight: 600, py: 0.2, px: 1, fontSize: '12px!important', minWidth: 'auto', boxShadow: 'none', whiteSpace: 'nowrap' }}
                >
                    {buttonLabel}
                </Button>
            </Tooltip>
        </Box>
    );
}
